import { render, staticRenderFns } from "./AddPermissionUserComponent.vue?vue&type=template&id=145c2499&"
import script from "./AddPermissionUserComponent.vue?vue&type=script&lang=js&"
export * from "./AddPermissionUserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports